import React, { useEffect, useState } from 'react';
import { TouchableOpacity, View } from "react-native"
import { useDispatch, useSelector } from "react-redux"
import Colors from '../../../constants/Colorsv2';
import { Text } from '../../../globalComponents/NativeOverrides';
import { event_getEventByEventId, event_getTeamByTeamId } from '../../../store/actionsv1/events';
import { market_getLatestTradesByEventId, market_setDraftOrder } from '../../../store/actionsv1/markets';
import { MarketProps, TradeProps } from '../../../store/types/mk_svc';
import { EventProps, TeamProps, TournamentProps } from '../../../store/types/sr_svc';
import { PlayerPickProps } from '../../../store/types/tp_svc';
import { market_getMarketsFromSupportedMarkets } from '../helpers/markets';
import { trade_getOrderFromTrade } from '../helpers/trades';
import MarketCard from './MarketCard';
import MarketCardFooter from './MarketCardFooter';

type TeamMarketCardProps = {
    navigation:any,
    event_id: string,
    event_type: 'team'|'tournament'|'match';
    market_override?:MarketProps,
    close_markets?:boolean,
    picks?: PlayerPickProps[],
    source?:'market'|'competition_create'|'competition_play'
    onCompPick?: (trade:TradeProps) => void
    team_id: string,
    hide_market_footers?:boolean,
}
const TeamMarketCard = ({ navigation, close_markets, event_id, picks, onCompPick, source, event_type, team_id, hide_market_footers, market_override }:TeamMarketCardProps) => {
    const [ loaded, setLoaded ] = useState(false);
    const dispatch = useDispatch()
    const market_type = useSelector((state:any) => state.auth.market_type, (left, right) => left == right)
    const event = useSelector((state:any) => state.event.events[event_id], (left, right) => {
        if(left.time_detail !== right.time_detail){ return false }
        return true
    })        
    const tournament = useSelector((state:any) => state.event.tournaments[event_id], (left, right) => left.tournament_id == right.tournament_id)
    const team = useSelector((state:any) => state.event.teams_list.teams.find((a:TeamProps) => a.team_id == team_id), (left, right) => left.team_id == right.team_id)
    const markets = useSelector((state:any) => state.market.markets, (left, right) => left.length === right.length)
     
    
    let available_markets:MarketProps[] = []
    if(event_type === 'team'){ available_markets = market_getMarketsFromSupportedMarkets(event?.supported_markets??[], markets) }
    if(event_type === 'tournament'){ available_markets = market_getMarketsFromSupportedMarkets(tournament?.supported_markets??[], markets) }
    useEffect(() => {
        if(!loaded){
            getDataFromServer(event_id, team_id)
        }
    },[])

    const getDataFromServer = async(event_id:string, team_id:string) => {
        if(!team) { dispatch(await event_getTeamByTeamId(team_id)) }
        if(!event && event_type === 'team') { dispatch(await event_getEventByEventId(event_id)) }
        dispatch(await market_getLatestTradesByEventId(event_id, event_type))
        setLoaded(true)
    }
    if(!team || !market_override){ return <></> }
    return (
        <View style={ styles.cardStyle }>
            <View style={{ flexDirection:'row' }}>
                <View nativeID='athlete-info' style={{ flex:1 }}>
                    <Text size={14} color={Colors.brand.midnight} weight='bold'>{team.market_name} {team.name}</Text>
                    <Text size={14} color={Colors.brand.midnight} weight='bold'>{market_override.description}</Text>
                </View>
                {!close_markets ?
                <View style={{ flex:1 }}>
                    {available_markets.map(m => {
                        if(market_override && market_override.market_id != m.market_id){ return }
                        let side_array:any = []
                        m.side_options.map(o => {
                            let side:any = { side: o.side }
                            if(o.id_source === 'team'){ side.side_id = team_id }
                            else { side.side_id = o }
                            side_array.push(side)
                        })
                        return (
                            <View style={{flex:1}}>
                                <MarketCard 
                                    align='horizontal' 
                                    market={m} 
                                    side_array={side_array} 
                                    event_id={event_id} 
                                    event_type={event_type} 
                                    onPress={(trade) => dispatch(market_setDraftOrder(trade_getOrderFromTrade(trade)))}
                                    />
                            </View>
                        )
                    })}
                </View>
                :<></>}
            </View>
            {!hide_market_footers && !close_markets ?
            <MarketCardFooter 
            open_order_count={0}
                onStatPress={() => navigation.push('Market', { event_type, event_id:tournament?.tournament_id, market_id: market_override.market_id, participant_id:team_id })}
                onMarketPress={() => navigation.push('Market', { event_type, event_id:tournament?.tournament_id, market_id: market_override.market_id, participant_id:team_id })}
                />
            :<></>}
        </View>
    )
}


const styles = {
    cardStyle: { padding:7, borderRadius: 12, borderWidth: 1, borderColor: Colors.shades.shade400 }
}

export default TeamMarketCard